import { atom } from 'jotai';

/**
 * Atom to control the visibility of the APS model settings panel
 * This is used to toggle the transform controls panel in the APS viewer
 */
const apsModelSettingsPanelVisibleAtom = atom<boolean>(false);

export default apsModelSettingsPanelVisibleAtom;
